/**
 * Client (Buyer Ledger) service.
 * Integrated with backend API
 */

import { apiClient } from './apiClient';

/**
 * Get all clients from API
 */
export const getClientList = async () => {
  try {
    const response = await apiClient.get(`/api/v1/clients`);
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch clients:', error);
    return [];
  }
};

/**
 * Get single client by ID
 */
export const getClientById = async (id) => {
  try {
    const response = await apiClient.get(`/api/v1/clients/${id}`);
    return response.data.data || null;
  } catch (error) {
    console.error('Failed to fetch client:', error);
    return null;
  }
};

/**
 * Save client (create or update)
 */
export const saveClient = async (client) => {
  try {
    if (client.id) {
      // Update existing client
      const response = await apiClient.patch(`/api/v1/clients/${client.id}`, client);
      return response.data.data;
    } else {
      // Create new client
      const response = await apiClient.post(`/api/v1/clients`, client);
      return response.data.data;
    }
  } catch (error) {
    console.error('Failed to save client:', error);
    throw error;
  }
};

/**
 * Delete client
 */
export const deleteClient = async (id) => {
  try {
    await apiClient.delete(`/api/v1/clients/${id}`);
    return true;
  } catch (error) {
    console.error('Failed to delete client:', error);
    throw error;
  }
};